"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var carousel_list_module_scss_1 = __importDefault(require("./carousel-list.module.scss"));
var CarouselItem_1 = __importDefault(require("../carousel-item/CarouselItem"));
var CarouselList = function (_a) {
    var _b;
    var id = _a.id, _c = _a.showVisibleScrollbar, showVisibleScrollbar = _c === void 0 ? false : _c, ulContainerElementRef = _a.ulContainerElementRef, handleKeyUp = _a.handleKeyUp, items = _a.items, numberOfItemsToShow = _a.numberOfItemsToShow, _d = _a.showPeek, showPeek = _d === void 0 ? false : _d, _e = _a.hasPadding, hasPadding = _e === void 0 ? false : _e;
    var pages = items.reduce(function (pagesArray, item, index) {
        var itemObject = { item: item, itemNumber: index + 1 };
        var pagesIndex = Math.floor(index / numberOfItemsToShow);
        if (!pagesArray[pagesIndex]) {
            pagesArray[pagesIndex] = []; // Start new page.
        }
        pagesArray[pagesIndex].push(itemObject);
        return pagesArray;
    }, []);
    var lessThanFullPageOfItems = function (pageLength, showPeek) {
        if (showPeek) {
            return (pageLength / numberOfItemsToShow) * 80;
        }
        else {
            return (pageLength / numberOfItemsToShow) * 100;
        }
    };
    return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    react_1.default.createElement("div", { className: (0, classnames_1.default)(carousel_list_module_scss_1.default['carousel-items-container'], (_b = {},
            _b[carousel_list_module_scss_1.default['visibleScrollbar']] = showVisibleScrollbar,
            _b[carousel_list_module_scss_1.default['padding']] = hasPadding,
            _b)), role: "list", "data-testid": "carousel-items-container", ref: ulContainerElementRef, id: id }, pages.map(function (page, index) {
        var _a;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(carousel_list_module_scss_1.default['carousel-page'], ["carousel-page-number-".concat(index)], (_a = {},
                _a[carousel_list_module_scss_1.default['full']] = page.length === numberOfItemsToShow,
                _a[carousel_list_module_scss_1.default['not-full']] = page.length !== numberOfItemsToShow,
                _a[carousel_list_module_scss_1.default['peek']] = showPeek,
                _a)), style: {
                flex: page.length !== numberOfItemsToShow
                    ? "0 0 ".concat(lessThanFullPageOfItems(page.length, showPeek), "%")
                    : null,
            }, "data-pageid": index, key: page[0].key }, page.map(function (itemObject, index) { return (react_1.default.createElement(CarouselItem_1.default, { item: itemObject.item, index: index, key: "contentKey-".concat(index), itemsCount: items.length, handleKeyUp: handleKeyUp, itemNumber: itemObject.itemNumber })); })));
    })));
};
exports.default = CarouselList;
//# sourceMappingURL=CarouselList.js.map